import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './estimate-data.reducer';
import { DocumentDataDispatcher } from '../document-data/document-data.dispatcher';
import { Estimate } from './estimate.model';
import { EstimateDataStore } from './estimate-data.store';
import { EstimateDataBuilder } from './estimate-data.builder';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { IEstimateDataDispatcher } from './estimate-data-dispatcher.interface';
import { EstimateStatusesEnum } from './estimate-data.data';
import {
  disableJobDialog,
  markEstimateAsDone,
  markSelectedEstimatesAsDone,
  enableJobDialog,
} from './estimate-data.actions';
import { SettingsDataStore } from '../settings-data/settings-data.store';

@Injectable()
export class EstimateDataDispatcher
  extends DocumentDataDispatcher<IState, Estimate>
  implements IEstimateDataDispatcher {
  constructor(
    store: Store<any>,
    estimateDataStore: EstimateDataStore,
    settingsDataStore: SettingsDataStore,
    estimateDataBuilder: EstimateDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      estimateDataStore,
      settingsDataStore,
      estimateDataBuilder,
      globalBannerService,
      translateService
    );
  }

  markEstimateAsDone(
    estimate: Estimate,
    estimateStatus: EstimateStatusesEnum,
    setEditingDocument: boolean,
    listFilter?: string
  ): Observable<Estimate> {
    const dispatchId = v4();

    this.store.dispatch(
      markEstimateAsDone(
        dispatchId,
        this.entityType,
        estimate,
        estimateStatus,
        setEditingDocument,
        listFilter
      )
    );

    return this.documentDataStore.getDispatchedResponse<Estimate>(dispatchId);
  }

  markSelectedEstimatesAsDone(
    estimateStatus: EstimateStatusesEnum,
    listFilter?: string
  ) {
    this.store.dispatch(
      markSelectedEstimatesAsDone(this.entityType, estimateStatus, listFilter)
    );
  }

  enableJobDialog(clientId: string, documentId: string) {
    this.store.dispatch(enableJobDialog(this.entityType, clientId, documentId));
  }

  disableJobDialog() {
    this.store.dispatch(disableJobDialog(this.entityType));
  }
}
